import { SET_HAS_PERSONAL_DATA } from '../actions/hasPersonalDataReducerActions';

let initialState = false;

const hasPersonalDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_HAS_PERSONAL_DATA:
            return action.payload.value
        default:
            return state;
    }
}

export default hasPersonalDataReducer;